import React from 'react'
import { useTaskTypeHierarchy } from '../../../Hooks/Features/TaskLayout/TaskTypeHierarchy/useTaskTypeHierarchy'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommonGrid from '../../../components/CommonCompo/CommonGrid/CommonGrid';
import { Dialog } from 'primereact/dialog';
import { renderField } from '../../../utils/Helper';
import _ from "underscore";
import CommanDialog from '../../../components/CommonCompo/CommanDialog/CommanDialog';

const TaskTypeHierarchy = () => {

    const { columns, rowData, loader, getTaskTypeHierarchy, formValues, setFormValues, formFields, saveTaskTypeHierarchy, filterIssueTypes } = useTaskTypeHierarchy();

    return (
        <div>
            <div className='sk-header-row d-flex gap-1 justify-content-end'>
                <button className='sk-btn sk-btn-primary' title='Refresh' onClick={() => getTaskTypeHierarchy()}><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
                <button className='sk-btn sk-btn-primary bg-black text-white' title='Create new hierarchy level' onClick={() => {setFormValues((prev) => ({...prev, visible: true})); filterIssueTypes();}}><FontAwesomeIcon icon="fa-solid fa-plus" />Level</button>
            </div>
            <div className='fw-semibold' style={{ height: "calc(100vh - 150px)", overflow: "auto" }}>
                <CommonGrid columns={columns} data={rowData?.length > 0 ? [{id: "all", title: "", children: rowData}] : []} headerHeight={40} rowHeight={"auto"} loader={loader?.grid} strippedTable={true} />
            </div>

            <Dialog visible={formValues?.visible} onHide={() => setFormValues({visible: false})} className='modal-small' header={`${formValues?.editData ? `Edit Hierarchy level ${formValues?.editData?.hierarchy_level}` : "Create"} Level`} draggable={false}>
                <div className='row'>
                    {formFields?.map((item, index) => (
                        renderField(item, index, (e, is_edit) => { setFormValues((prev) => ({ ...prev, [item?.name]: e?.target?.value })) }, formValues, {}, {}, () => { }, () => { })
                    ))}
                    <div className='d-flex gap-1 justify-content-end align-items-center mt-2'>
                        <button className='sk-btn sk-btn-primary' onClick={() => setFormValues({ visible: false })}>Cancel</button>
                        {loader?.btn ? <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "45px" }}>
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => saveTaskTypeHierarchy()}>Save</button>
                        }
                    </div>
                </div>
            </Dialog>

            <CommanDialog visible={formValues?.isDelete} handleClose={() => setFormValues({ visible: false })} handleFun={() => saveTaskTypeHierarchy()} message="Are you sure you want to delete this hierarchy level?"/>
        </div>
    )
}

export default TaskTypeHierarchy